export const createSiteTypeQueryParam = (selectedSiteTypes: string) => {
  const siteTypes = selectedSiteTypes.split(',');
  const queryParams = siteTypes.map((type) => `siteType=${type.toUpperCase()}`);
  const result = queryParams.join('&');

  return result;
};
